import { Modal } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import React, { useState } from "react";
import StandardButton from "../buttons/standard.button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { statisticLogger } from "../../statisticLogger/StatisticLogger.container";

const ADD_FEEDBACK = `
  mutation AddFeedback($sessionKey: String!, $content: String!, $title: String) {
    addFeedback(sessionKey: $sessionKey, content: $content, title: $title)
  }
`;

export default function ContactModal({ setShowContactForm }) {
  const [pending, setPending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const intl = useIntl();

  const onHide = () => {
    setShowContactForm(false);
  };

  const handleSubmit = async (e) => {
    setPending(true);
    setSuccess(false);
    setFailure(false);
    e.preventDefault();

    const title = e.target.elements.title.value.trim().length
      ? e.target.elements.title.value
      : undefined;
    const content = e.target.elements.content.value.trim();

    try {
      const response = await fetch(process.env.REACT_APP_NEXT_GRAPHQL_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: ADD_FEEDBACK,
          variables: {
            sessionKey: statisticLogger._serverSessionKey,
            content,
            title,
          },
        }),
      });
      await response.json();
      setSuccess(true);
      setTimeout(() => onHide(), 5000);
    } catch (e) {
      setFailure(true);
    }
    setPending(false);
  };

  return (
    <Modal centered={true} show={true} backdrop="static" keyboard={false}>
      <Modal.Header closeButton onHide={onHide}>
        <h1>
          <FormattedMessage id="contactForm.title" />
        </h1>
      </Modal.Header>
      <Modal.Body>
        {success && (
          <div className="alert alert-success">
            <FormattedMessage id="contactForm.success" />
          </div>
        )}

        {failure && (
          <div className="alert alert-danger">
            <FormattedMessage id="contactForm.failed" />
          </div>
        )}

        <div>
          <FormattedMessage id="contactForm.text" />
        </div>
        <form onSubmit={handleSubmit}>
          <div>
            <input
              type="text"
              id="title"
              className="w-100 my-3"
              placeholder={intl.formatMessage({
                id: "contactForm.formTitle",
              })}
            />
          </div>
          <div>
            <textarea
              required
              className="w-100"
              id="content"
              placeholder={
                intl.formatMessage({
                  id: "contactForm.formContent",
                }) + "*"
              }
              rows={4}
            />
            <small className="d-block mb-4">
              <FormattedMessage id="legal.NoteNotTransmitAnySensitiveData" />
            </small>
          </div>
          <StandardButton>
            {pending && (
              <FontAwesomeIcon
                icon={["fal", "spinner"]}
                spin
                className="mr-3"
              />
            )}
            <FormattedMessage id="contactForm.submit" />
          </StandardButton>
        </form>
      </Modal.Body>
    </Modal>
  );
}
